import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useAuth } from "../providers/authprovider";

export const LOGO_MAX_SIZE = 5 * 1024 * 1024;

export function validateLogoFile(file) {
  if (!file) return "";

  if (!file.type || !file.type.startsWith("image/"))
    return "Logo musi być plikiem graficznym.";

  if (file.size > LOGO_MAX_SIZE) return "Logo może mieć maksymalnie 5 MB.";

  return "";
}

// Logo/pieczątka siedzą za `auth`, wiec nie da sie ich wpiac wprost w src - trzeba
// pobrac plik przez API i zrobic z niego object URL.
export default function RajcompanyLogo({
  companyId,
  hasLogo,
  height = 32,
  type = "logo",
}) {
  const { rajcompanies } = useAuth();
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const getFile =
    type === "stamp"
      ? rajcompanies.getStamp
      : type === "fire_certificate"
        ? rajcompanies.getFireCertificate
        : rajcompanies.getLogo;
  const label =
    type === "stamp"
      ? "Pieczątka spółki"
      : type === "fire_certificate"
        ? "Świadectwo przeciwpożarowe spółki"
        : "Logo spółki";

  useEffect(() => {
    if (!companyId || !hasLogo) {
      setUrl(null);
      setFailed(false);
      return;
    }

    let objectUrl = null;
    let cancelled = false;

    setLoading(true);
    setFailed(false);

    getFile(companyId, ({ success, content }) => {
      if (cancelled) return;

      setLoading(false);

      if (!success) {
        setFailed(true);
        return;
      }

      objectUrl = URL.createObjectURL(
        new Blob([content.file], { type: content.type }),
      );
      setUrl(objectUrl);
    });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [companyId, hasLogo, getFile]);

  if (!hasLogo) return <span className="text-muted">Brak</span>;

  if (loading) return <Spinner size="sm" />;

  if (failed || !url) return <span className="text-muted">Brak</span>;

  return (
    <img
      src={url}
      alt={label}
      style={{ height: height, maxWidth: height * 4, objectFit: "contain" }}
    />
  );
}
